// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__13Ryl","modalFooterButton":"ModalNotes_modalFooterButton__1qKb0"};